exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thin-button-wrapper button.thin-wrapper-button {\n  width: 220px;\n  overflow: clip;\n  position: relative;\n}\n.thin-button-wrapper button.thin-wrapper-button span {\n  white-space: nowrap;\n}\n.thin-button-wrapper button.thin-wrapper-button.hide-text {\n  width: 30px;\n}", ""]);

// exports
